import { useLayoutEffect, useMemo } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { CheckIn } from './pages/CheckIn.js'
import { Menu } from './pages/Menu.js'
import { ItemDetail } from './pages/ItemDetail.js'
import { Cart } from './pages/Cart.js'
import { Payment } from './pages/Payment.js'
import { OrderTracker } from './pages/OrderTracker.js'
import { Cuenta } from './pages/Cuenta.js'
import { StadiumContext, applyStadiumMode, resolveStadiumMode, slugFromPath } from './lib/stadium.js'

/**
 * Routes:
 *   /r/:slug/t/:qrCode          → check-in (QR de mesa o de takeout)
 *   /r/:slug/menu               → menu grid
 *   /r/:slug/item/:productId    → item detail (qty + notes)
 *   /r/:slug/cart               → review + enviar (mesa: a cocina · takeout: a pago)
 *   /r/:slug/pago/:orderId      → OhSir takeout: paso de PAGO (mostrador)
 *   /r/:slug/order/:orderId     → tracker (polling 5s)
 *   /r/:slug/cuenta             → cuenta agregada (placeholder MVP)
 */
export default function App() {
  // Modo estadio (por negocio): `?modo=estadio` o VITE_STADIUM_SLUGS. Sin él, el
  // guest se ve y funciona igual que siempre. Ver lib/stadium.ts.
  const { pathname, search } = useLocation()
  const stadium = useMemo(() => resolveStadiumMode(slugFromPath(pathname), search), [pathname, search])
  useLayoutEffect(() => { applyStadiumMode(stadium) }, [stadium])
  return (
    <StadiumContext.Provider value={stadium}>
    <Routes>
      <Route path="/r/:slug/t/:qrCode" element={<CheckIn />} />
      <Route path="/r/:slug" element={<CheckIn />} />
      <Route path="/r/:slug/menu" element={<Menu />} />
      <Route path="/r/:slug/item/:productId" element={<ItemDetail />} />
      <Route path="/r/:slug/cart" element={<Cart />} />
      <Route path="/r/:slug/pago/:orderId" element={<Payment />} />
      <Route path="/r/:slug/order/:orderId" element={<OrderTracker />} />
      <Route path="/r/:slug/cuenta" element={<Cuenta />} />
      <Route path="*" element={<Fallback />} />
    </Routes>
    </StadiumContext.Provider>
  )
}

function Fallback() {
  return (
    <div className="app">
      <div className="container">
        <div className="welcome">
          <img src="/favicon.svg" alt="" className="big-logo" />
          <h1>Nintai<em>GO</em></h1>
          <p>Escanea el QR de tu mesa para empezar.</p>
        </div>
      </div>
    </div>
  )
}
